import React from 'react';
import {
	ReactHookFormDateField,
	type ReactHookFormDateFieldProps,
} from '@netx/core-components/Form/DateField';
import type {ICustomFormItem, CustomFormFormValues} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';

export interface ReactHookFormCustomFormItemDateProps<
	TValues extends CustomFormFormValues = CustomFormFormValues,
> extends Omit<
		ReactHookFormDateFieldProps<TValues>,
		'label' | 'name' | 'required'
	> {
	item: ICustomFormItem;
}

export const ReactHookFormCustomFormItemDatePrimitive = <
	TValues extends CustomFormFormValues = CustomFormFormValues,
>({
	item,
	...props
}: ReactHookFormCustomFormItemDateProps<TValues>) => {
	const {label, required} = item;

	return (
		<ReactHookFormDateField
			fullWidth
			{...props}
			label={getCustomFormItemTranslatedLabel(label)}
			name={getCustomFormBaseFieldName(item)}
			required={required}
		/>
	);
};

export const ReactHookFormCustomFormItemDate =
	ReactHookFormCustomFormItemDatePrimitive;

export default ReactHookFormCustomFormItemDate;
